var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking_container"},[_c('font-awesome-icon',{staticStyle:{"font-size":"2rem"},attrs:{"icon":"wrench"}}),_c('br'),_c('h4',[_vm._v(" under construction ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }